import React from "react";
import styled from "styled-components";
import SafeHtml from "../Html/SafeHtml";
import { Device } from "../device";

const OEmbedContainer = styled.div`
    position: relative;
    ${Device.mobileMax} {
        margin-bottom: 1.5rem;
    }
    iframe {
        margin: 0px auto 10px;
        height: 40vh;
    }
`;

interface Props
{
    html: string;
}

const OEmbed: React.FunctionComponent<Props> = (props) =>
{
    return (
        <OEmbedContainer>
            <SafeHtml html={props.html}></SafeHtml>
        </OEmbedContainer>
    );
};

export default OEmbed;
